export default {
  pathRegister: ['Novo Cadastro de Pastas'],
  pathEdit: ['Editar Cadastro de Pastas'],
  groupTitle: 'Informe a Pasta:',
  labelName: 'Nome*',
  labelResponsavel: 'Responsável por solicitar a criação da pasta',
  labelAtributo: 'Pasta Pública',
};
